/**
 * Created by ren on 13/07/2017.
 */
import { ACCOUNT, SUBSIDIARY, LOCATION } from '../../constants/constant_preference_types';
import * as DocType from '../../constants/constant_doc_types';


export const buildFiltersForAccount = () => {
  return {
    type : ACCOUNT,
    query: [ { pref_type: ACCOUNT, doc_type: DocType.PREFERENCE } ]
  };
};

export const buildFiltersForSubsidiary = ( subsidiaryId ) => {
  return {
    type_id: subsidiaryId,
    type   : SUBSIDIARY,
    query: [{ pref_type: ACCOUNT, doc_type: DocType.PREFERENCE },
      { pref_type: SUBSIDIARY, doc_type: DocType.PREFERENCE, type_id: subsidiaryId } ]
  };
};

export const buildFiltersForLocation = ( locationId, subsidiaryId ) => {
  return {
    type_id: locationId,
    type   : LOCATION,
    query: [{ pref_type: ACCOUNT, doc_type: DocType.PREFERENCE },
      { pref_type: SUBSIDIARY, doc_type: DocType.PREFERENCE, type_id: subsidiaryId },
      { pref_type: LOCATION, doc_type: DocType.PREFERENCE, type_id: locationId } ]
  };
};


export const buildPreferenceFilters = (formValues, settings, accountId) => {
  const {pref_type, type_id, subsidiary_id} = formValues;
  if(pref_type === ACCOUNT){
    const filters = {
      pref_types: [ACCOUNT],
      type_ids: [accountId],
      settings,
    };
    return filters;
  } 
  
  else if(pref_type === SUBSIDIARY){
    const filters = {
      pref_types: [ACCOUNT, SUBSIDIARY],
      type_ids: [accountId, type_id],
      settings 
    };
    return filters;
  } 
  
  else if(pref_type === LOCATION){
    const filters = {
      pref_types: [ACCOUNT, SUBSIDIARY, LOCATION],
      type_ids: [accountId, subsidiary_id, type_id],
      settings
    };
    return filters;
  }

  return {};
}
